import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

const invalidateQueries = ['klearAccount.list', 'klearAccount.getById', 'klearAccount.getTransactions']

export function useBankTransferMutations() {
  const createInboundTransferMutation = useMutationWithToast(
    trpc.bankTransfer.createInboundTransfer.useMutation,
    createToastConfig('Inbound Transfer', 'create'),
    {
      invalidateQueries
    }
  )

  const createOutboundTransferMutation = useMutationWithToast(
    trpc.bankTransfer.createOutboundTransfer.useMutation,
    createToastConfig('Outbound Transfer', 'create'),
    {
      invalidateQueries
    }
  )

  return {
    createInboundTransfer: createInboundTransferMutation.mutateAsync,
    createOutboundTransfer: createOutboundTransferMutation.mutateAsync,
    isCreating: createInboundTransferMutation.isPending || createOutboundTransferMutation.isPending
  }
}
